import React from "react";

// Components
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import CTAButtonsSection from "./components/CTAButtonsSection";
import SectorsSection from "./components/SectorsSection";
import SolutionsSection from "./components/SolutionsSection";
import WhyDifferentSection from "./components/WhyDifferentSection";
import LogosSection from "./components/LogosSection";
import AppSection from "./components/AppSection";
import HowItWorksSection from "./components/HowItWorksSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

// Hooks
import useTailwindLoader from "./hooks/useTailwindLoader";

export default function LandingPage() {
  useTailwindLoader();

  return (
    <main className="font-raleway bg-[#FAFAFA] min-h-screen">
      <Header />
      <HeroSection />
      <CTAButtonsSection />
      <SectorsSection />
      <SolutionsSection />
      <LogosSection />
      <WhyDifferentSection />
      <HowItWorksSection />
      <AppSection />      
      <ContactSection />
      <Footer />
    </main>
  );
}
